import { render, staticRenderFns } from "./informDepartment.vue?vue&type=template&id=e6b0fc2c&scoped=true"
import script from "./informDepartment.vue?vue&type=script&lang=js"
export * from "./informDepartment.vue?vue&type=script&lang=js"
import style0 from "./informDepartment.vue?vue&type=style&index=0&id=e6b0fc2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0fc2c",
  null
  
)

export default component.exports